import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import cn from 'classnames';
import { Row, Col } from 'react-bootstrap';

import Title from '../event_components/title';
import Time from '../event_components/time';
import styles from './mobile.scss';
import AttendButton from '../event_components/attend_button';
import AddEventToCalendar from '../event_components/add_to_calendar';
import { LocaleWrapper } from '../../locale-wrapper';
import TicketPurchasing from '../event_components/ticket-purchasing';
import TwitchPreviousVideo from '../event_components/twitch-video';
import CheckoutController from '../event_components/Checkout';
import { attendButtonIsVisible } from './utils';

class Mobile extends React.Component {
  constructor() {
    super();
    this.state = {
      openTicketing: false,
    };
  }
  toggleAttendButton = () => {
    this.props.onResizeComponent();
    this.setState({
      openTicketing: !this.state.openTicketing,
    });
  };

  render() {
    const { settings, event, onResizeComponent } = this.props;

    if (event.get('initial_embed') || event.get('is_offline')) {
      return event.get('is_offline') ? (
        <TwitchPreviousVideo settings={settings} event={event} />
      ) : (
        <TicketPurchasing event={event} settings={settings} open />
      );
    }

    return (
      <CheckoutController
        variant="default"
        event={event}
        settings={settings}
        openTicketing={this.state.openTicketing}
        onResizeComponent={onResizeComponent}
        onClose={() => {
          this.setState({
            openTicketing: false,
          });
        }}
      >
        <div className={cn(styles.mobileEvent, 'event', styles.padded, 'minimal')}>
          <Row className={styles.mobile} center="xs" middle="xs">
            <Col xs={12}>
              <Title event={event} className={styles.title} settings={settings} />
            </Col>
          </Row>
          <Row center="xs" middle="xs">
            <Col xs={12}>
              <Time event={event} settings={settings} className={styles.time} format="MMM D" />
            </Col>
          </Row>
          <Row className={cn(styles.content, styles.center)}>
            <Col xs={12}>
              {settings.get('enableAddToCalendar') && (
                <div className={styles.addCalendar}>
                  <AddEventToCalendar event={event} settings={settings} />
                </div>
              )}
            </Col>

            {attendButtonIsVisible(event, settings) && (
              <AttendButton event={event} settings={settings} className={styles.attendButton} handleButtonClick={this.toggleAttendButton} />
            )}
          </Row>
        </div>
      </CheckoutController>
    );
  }
}

Mobile.propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

function MobileContainer({ event, settings, onResizeComponent }) {
  return (
    <LocaleWrapper event={event}>
      {settings.get('removeAttendButton') && !settings.get('removeUrlLink') ? (
        <a href={event.get('url')} target="_blank" rel="noopener noreferrer">
          <Mobile event={event} settings={settings} onResizeComponent={onResizeComponent} />
        </a>
      ) : (
        <Mobile event={event} settings={settings} onResizeComponent={onResizeComponent} />
      )}
    </LocaleWrapper>
  );
}

export default MobileContainer;
